import {
  PluginConfigurationApi,
  PluginDefinitionResponse,
  PluginMappingConfigResponse,
  PluginMappingResponse,
  PluginType,
  GetPluginMappingConfigRequest,
  GetPluginSchemaRequest,
  ListPluginDefinitionsRequest,
  ListPluginMappingsRequest,
  UpsertPluginMappingOperationRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'
import { PluginJsonSchema } from '@Components/plugins/plugin-schema-types'

const listDefinitions = async (type?: PluginType): Promise<PluginDefinitionResponse[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

  const request: ListPluginDefinitionsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    type,
  }

  return await api.listPluginDefinitions(request)
}

const getSchema = async (pluginId: string): Promise<PluginJsonSchema> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

  const request: GetPluginSchemaRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    pluginId,
  }

  return await api.getPluginSchema(request)
}

const listMappings = async (): Promise<PluginMappingResponse[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

  const request: ListPluginMappingsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.listPluginMappings(request)
}

const getMappingConfig = async (
  type: PluginType,
  refId?: string,
): Promise<PluginMappingConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

  const request: GetPluginMappingConfigRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    type,
    refId,
  }

  return await api.getPluginMappingConfig(request)
}

const upsertMapping = async (
  type: PluginType,
  pluginId: string,
  refId?: string,
  config?: Record<string, unknown>,
): Promise<PluginMappingResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PluginConfigurationApi)

  const request: UpsertPluginMappingOperationRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    type,
    upsertPluginMappingRequest: {
      pluginId,
      refId,
      config,
    },
  }

  return await api.upsertPluginMapping(request)
}

export const PluginServiceAPI = {
  listDefinitions,
  getSchema,
  listMappings,
  getMappingConfig,
  upsertMapping,
}
